module.exports = __webpack_public_path__ + "files/ABI_POCM_1227.pdf";